import { LabClient } from 'models/client-directory';
import { ClientDirInvoiceSettingsFormData } from 'models/forms';
import { Organization } from 'models/organization';

export const emptyInvoiceSettingsData = (currentLab: Organization, labClient?: LabClient) => {
    return {
        paymentTerms:
            labClient?.invoiceSettings?.paymentTerms || currentLab.invoicing?.defaultSetting?.paymentTerms || 30,
        invoiceFee: {
            price: labClient?.invoiceSettings?.invoiceFee?.price || 0,
            currency: labClient?.invoiceSettings?.invoiceFee?.currency,
        },
        deliveryFee: {
            price: labClient?.invoiceSettings?.deliveryFee?.price || 0,
            currency: labClient?.invoiceSettings?.deliveryFee?.currency,
        },
        isDeliveryNoteAttached:
            labClient?.invoiceSettings?.isDeliveryNoteAttached !== null
                ? labClient?.invoiceSettings?.isDeliveryNoteAttached
                : true,
        isDeliveryNotesMergedWithInvoice: labClient?.invoiceSettings?.isDeliveryNotesMergedWithInvoice ?? false,
        invoiceText: labClient?.invoiceSettings?.invoiceText,
        showPatientPIN: labClient?.invoiceSettings?.showPatientPIN || false,
        fortnoxCustomerNo: labClient?.invoiceSettings?.fortnoxCustomerNo || '',
        vismaCustomerId: labClient?.invoiceSettings?.vismaCustomerId || '',
    } as ClientDirInvoiceSettingsFormData;
};
